import React from "react";
//import { ReactSVG } from "react-svg";
import JetiLogo from './images/logos/pmg-logos-jeti.png';
import BellAirLogo from './images/logos/pmg-logos-bellair.png';
import MightyTrueLogo from './images/logos/pmg-logos-mightytrue.png';
//import OrderAILogo from './images/logos/pmg-logos-order-ai.png';
import RealityAILogo from './images/logos/pmg-logos-reality-ai.png';
import TeslaLogo from './images/logos/pmg-logos-tesla.png';
import HungerRushLogo from './images/logos/pmg-logos-hungerrush.png';
import AppgateLogo from './images/logos/pmg-logos-appgate.png';
import PayrocLogo from './images/logos/pmg-logos-payroc.png';
import PersonaLogo from './images/logos/pmg-logos-persona.png';
//import Studio88Logo from './images/logos/pmg-logos-studio88.png';
import PsychoBunnyLogo from './images/logos/pmg-logos-psychobunny.png';

const Logos = [
    { src: JetiLogo, alt: "Jeti logo", width: 144, height: 28 },
    { src: BellAirLogo, alt: "Bell Air logo", width: 144, height: 12 },
    { src: MightyTrueLogo, alt: "Mighty & True logo", width: 144, height: 4 },
    /*{ src: OrderAILogo, alt: "Order AI logo", width: 144, height: 8 },*/
    { src: RealityAILogo, alt: "Reality AI logo", width: 144, height: 36 },
    { src: TeslaLogo, alt: "Tesla logo", width: 144, height: 12 },
    { src: HungerRushLogo, alt: "Hunger Rush logo", width: 144, height: 12 },
    { src: AppgateLogo, alt: "Appgate logo", width: 144, height: 12 },
    { src: PayrocLogo, alt: "Payroc logo", width: 144, height: 12 },
    { src: PersonaLogo, alt: "Persona logo", width: 144, height: 12 },
    /*{ src: Studio88Logo, alt: "Studio 88 logo", width: 144, height: 12 },*/
    { src: PsychoBunnyLogo, alt: "Psycho Bunny logo", width: 144, height: 12 }
];

const LogoBanner = () => {

    return (
        <div className="py-12 px-24 flex flex-col justify-center items-center">
            <div className="bg-gradientBorder w-full h-[1px]"></div>
            <div className="logo-scroll-container py-12 w-screen overflow-hidden flex flex-col justify-center items-start md:h-36">
                <div className="flex flex-row flex-nowrap items-center gap-10 md:gap-20 animate-[marquee_40s_linear_infinite] md:animate-[marquee_80s_linear_infinite]">
                    <div className="flex flex-row items-center gap-10 md:gap-20 shrink-0 w-max">
                        {Logos.map((logo, index) => (
                            <img key={`a-${index}`} src={logo.src} alt={logo.alt} loading="lazy" decoding="async" width={logo.width} height={logo.height} className="max-h-20 min-h-5 w-auto object-contain flex-none"/>
                        ))}
                    </div>
                    <div className="flex flex-row items-center gap-10 md:gap-20 shrink-0 w-max" aria-hidden="true">
                        {Logos.map((logo, index) => (
                            <img key={`b-${index}`} src={logo.src} alt={logo.alt} loading="lazy" decoding="async" width={logo.width} height={logo.height} className="max-h-20 min-h-5 w-auto object-contain flex-none"/>
                        ))}
                    </div>
                </div>
            </div>
            <div className="bg-gradientBorder w-full h-[1px]"></div>
        </div>
    )
}

export default LogoBanner;